import Editor from '@diligentcorp/ckeditor5-assets';

export const editorConfig = {
  ...Editor.defaultConfig,
  toolbar: {
    items: [
      'heading',
      '|',
      'bold',
      'italic',
      'underline',
      '|',
      'removeFormat',
      '|',
      'alignment',
      '|',
      'bulletedList',
      'numberedList',
      '|',
      'outdent',
      'indent',
      '|',
      'link',
      'unlink',
      '|',
      'maximize',
      '|',
      'undo',
      'redo',
    ],
    shouldNotGroupWhenFull: true,
  },
  list: {
    properties: {
      styles: false,
    },
  },
  removePlugins: [
    'FontBackgroundColor',
    'FontColor',
    'Image',
    'Table',
    'TableCaption',
    'TableCellProperties',
    'TableColumnResize',
    'TableProperties',
    'TableToolbar',
    'WordCount',
  ],
  wordCount: {
    displayWords: false,
    displayCharacters: false,
  },
};
